var map = {
	"./iress-alert_45.entry.js": [
		2193,
		535,
		901,
		255,
		237,
		553,
		193
	],
	"./iress-backdrop.entry.js": [
		8174,
		174
	],
	"./iress-checkbox-mark.entry.js": [
		380,
		380
	],
	"./iress-close-button.entry.js": [
		7869,
		535,
		869
	],
	"./iress-color-swatch.entry.js": [
		6486,
		535,
		237,
		486
	],
	"./iress-label.entry.js": [
		2943,
		535,
		943
	],
	"./iress-overlay-panel.entry.js": [
		4685,
		535,
		553,
		685
	],
	"./iress-placeholder.entry.js": [
		6013,
		535,
		13
	],
	"./iress-spinner.entry.js": [
		2741,
		535,
		741
	],
	"./iress-tag.entry.js": [
		2076,
		535,
		76
	],
	"./iress-theme-editor.entry.js": [
		2465,
		535,
		901,
		255,
		465
	],
	"./iress-toast.entry.js": [
		9567,
		535,
		901,
		567
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4117;
module.exports = webpackAsyncContext;